// Custom script by XNEST
// Product personalisation, gift packaging and engraving preview

(function() {
    if (window.__xnAddonCartHandlerInstalled) return;
    window.__xnAddonCartHandlerInstalled = true;

    function getRoot() {
        return window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    }

    function getMainProductForm(target) {
        const form = target.closest && target.closest('form[action*="/cart/add"]');
        if (form) return form;
        return document.querySelector('form[action*="/cart/add"]');
    }

    function normalizeEngravingValue(value) {
        return String(value || '').replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').slice(0, 2).map(function(line) {
            return line.slice(0, 16);
        }).join('\n');
    }

    function getEngravingCountText(value) {
        const normalisedValue = normalizeEngravingValue(value);
        const lines = normalisedValue.split('\n');
        const lineOneLength = lines[0] ? lines[0].length : 0;
        const lineTwoLength = lines[1] ? lines[1].length : 0;
        if (lines.length > 1) {
            return lineOneLength + '/16 · ' + lineTwoLength + '/16';
        }
        return lineOneLength + ' / 16';
    }

    function resetAutoFitText(textEl) {
        if (!textEl) return;
        textEl.style.fontSize = '';
        textEl.style.lineHeight = '';
    }

    function autoFitMetalTagText(textEl) {
        if (!textEl) return;
        const tag = textEl.closest('.xn-addon-box__metal-tag');
        if (!tag) return;
        resetAutoFitText(textEl);
        const text = textEl.textContent || '';
        const isPlaceholder = textEl.classList.contains('is-placeholder');
        const lines = text.split('\n');
        const hasTwoLines = lines.length > 1;
        const longestLineLength = lines.reduce(function(max, line) {
            return Math.max(max, line.length);
        }, 0);
        let fontSize = isPlaceholder ? 13 : 56;
        const minFontSize = isPlaceholder ? 11 : 12;
        if (hasTwoLines) {
            fontSize = isPlaceholder ? 13 : 38;
        }
        /*
          For long engraving text, start smaller.
          For two-line engraving, use a softer reduction so the text can still stay large.
        */
        if (!isPlaceholder && longestLineLength > 10) {
            fontSize = hasTwoLines ? Math.floor(fontSize * 0.82) : Math.floor(fontSize * 0.7);
        }
        textEl.style.fontSize = fontSize + 'px';
        textEl.style.lineHeight = hasTwoLines ? '1.18' : '1';
        let guard = 0;
        while (guard < 100 && fontSize > minFontSize && (textEl.scrollWidth > tag.clientWidth * 0.9 || textEl.scrollHeight > tag.clientHeight * 0.72)) {
            fontSize -= 1;
            textEl.style.fontSize = fontSize + 'px';
            guard += 1;
        }
    }

    function autoFitAllMetalTagTexts() {
        document.querySelectorAll('.xn-addon-box__metal-tag-text[data-xn-autofit]').forEach(function(textEl) {
            autoFitMetalTagText(textEl);
        });
    }

    function createMetalTagPreview(label, text, isPlaceholder) {
        const wrap = document.createElement('div');
        wrap.className = 'xn-addon-box__metal-tag-wrap';
        if (label) {
            const labelEl = document.createElement('p');
            labelEl.className = 'xn-addon-box__metal-tag-label';
            labelEl.textContent = label;
            wrap.appendChild(labelEl);
        }
        const tag = document.createElement('div');
        tag.className = 'xn-addon-box__metal-tag';
        const textEl = document.createElement('p');
        textEl.className = 'xn-addon-box__metal-tag-text';
        textEl.setAttribute('data-xn-autofit', 'true');
        if (isPlaceholder) {
            textEl.classList.add('is-placeholder');
        }
        textEl.textContent = text;
        tag.appendChild(textEl);
        wrap.appendChild(tag);
        window.requestAnimationFrame(function() {
            autoFitMetalTagText(textEl);
        });
        return wrap;
    }

    function parseVariantId(value) {
        const id = Number(value);
        if (!value || Number.isNaN(id) || id <= 0) {
            return null;
        }
        return id;
    }

    function getSelectedPersonalisation() {
        const personalisationBox = document.getElementById('personalisationBox');
        const personalisationCheckbox = document.getElementById('personalisationCheckbox');
        if (!personalisationBox || !personalisationCheckbox || !personalisationCheckbox.checked) {
            return null;
        }
        const selected = personalisationBox.querySelector('input[name="personalisation_option"]:checked');
        if (!selected) {
            personalisationBox.classList.add('has-error');
            throw new Error('Please choose a personalisation option.');
        }
        const mode = selected.dataset.mode || 'none';
        // Original Metal Tag / No Engraving is a free/default option.
        // It should not be added as a separate add-on cart item.
        if (mode === 'none') {
            return null;
        }
        const selectedVariantId = parseVariantId(selected.value);
        if (!selectedVariantId) {
            personalisationBox.classList.add('has-error');
            throw new Error('The selected personalisation option is not available. Please refresh the page or choose another option.');
        }
        const sideOneInput = document.getElementById('personalisationSideOneInput');
        const sideTwoInput = document.getElementById('personalisationSideTwoInput');
        const sideOneValue = sideOneInput ? normalizeEngravingValue(sideOneInput.value).trim() : '';
        const sideTwoValue = sideTwoInput ? normalizeEngravingValue(sideTwoInput.value).trim() : '';
        if (mode === 'one' && !sideOneValue) {
            personalisationBox.classList.add('has-error');
            if (sideOneInput) sideOneInput.focus();
            throw new Error('Please enter the engraving text.');
        }
        if (mode === 'two' && (!sideOneValue || !sideTwoValue)) {
            personalisationBox.classList.add('has-error');
            if (!sideOneValue && sideOneInput) {
                sideOneInput.focus();
            } else if (sideTwoInput) {
                sideTwoInput.focus();
            }
            throw new Error('Please enter the engraving text for both sides.');
        }
        return {
            id: selectedVariantId,
            title: selected.dataset.title || 'Personalisation',
            mode: mode,
            sideOneText: sideOneValue,
            sideTwoText: sideTwoValue
        };
    }

    function getSelectedGift() {
        const giftBox = document.getElementById('giftReadyBox');
        const giftCheckbox = document.getElementById('giftReadyCheckbox');
        if (!giftBox || !giftCheckbox || !giftCheckbox.checked) {
            return null;
        }
        const selected = giftBox.querySelector('input[name="gift_packaging_option"]:checked');
        if (!selected) {
            giftBox.classList.add('has-error');
            throw new Error('Please choose a gift packaging option.');
        }
        const selectedVariantId = parseVariantId(selected.value);
        if (!selectedVariantId) {
            giftBox.classList.add('has-error');
            throw new Error('The selected gift packaging option is not available. Please refresh the page or choose another option.');
        }
        return {
            id: selectedVariantId,
            title: selected.dataset.title || 'Gift Packaging'
        };
    }

    function updatePersonalisationUi() {
        const personalisationBox = document.getElementById('personalisationBox');
        const personalisationCheckbox = document.getElementById('personalisationCheckbox');
        if (!personalisationBox || !personalisationCheckbox) return;
        const selected = personalisationBox.querySelector('input[name="personalisation_option"]:checked');
        const mode = selected ? selected.dataset.mode : 'none';
        const sideOneInput = document.getElementById('personalisationSideOneInput');
        const sideTwoInput = document.getElementById('personalisationSideTwoInput');
        const sideOneCount = document.getElementById('personalisationSideOneCount');
        const sideTwoCount = document.getElementById('personalisationSideTwoCount');
        const sideOneField = document.getElementById('personalisationSideOneField');
        const sideTwoField = document.getElementById('personalisationSideTwoField');
        const preview = document.getElementById('personalisationPreview');
        const checked = personalisationCheckbox.checked;
        if (sideOneInput) {
            const normalisedSideOne = normalizeEngravingValue(sideOneInput.value);
            if (sideOneInput.value !== normalisedSideOne) {
                sideOneInput.value = normalisedSideOne;
            }
        }
        if (sideTwoInput) {
            const normalisedSideTwo = normalizeEngravingValue(sideTwoInput.value);
            if (sideTwoInput.value !== normalisedSideTwo) {
                sideTwoInput.value = normalisedSideTwo;
            }
        }
        const sideOneValue = sideOneInput ? sideOneInput.value.trim() : '';
        const sideTwoValue = sideTwoInput ? sideTwoInput.value.trim() : '';
        personalisationBox.classList.toggle('is-active', checked);
        personalisationBox.classList.toggle('has-engraving', checked && mode !== 'none');
        personalisationBox.classList.remove('has-error');
        if (sideOneField) {
            sideOneField.style.display = checked && (mode === 'one' || mode === 'two') ? 'block' : 'none';
        }
        if (sideTwoField) {
            sideTwoField.style.display = checked && mode === 'two' ? 'block' : 'none';
        }
        if (sideOneCount) {
            sideOneCount.textContent = getEngravingCountText(sideOneInput ? sideOneInput.value : '');
        }
        if (sideTwoCount) {
            sideTwoCount.textContent = getEngravingCountText(sideTwoInput ? sideTwoInput.value : '');
        }
        if (preview) {
            preview.innerHTML = '';
            if (!checked) {
                preview.appendChild(createMetalTagPreview('', 'Your engraving will appear here', true));
            } else if (mode === 'two') {
                preview.appendChild(createMetalTagPreview('Side 1', sideOneValue || 'Side 1 engraving', !sideOneValue));
                preview.appendChild(createMetalTagPreview('Side 2', sideTwoValue || 'Side 2 engraving', !sideTwoValue));
            } else if (mode === 'one') {
                preview.appendChild(createMetalTagPreview('', sideOneValue || 'Your engraving will appear here', !sideOneValue));
            } else {
                preview.appendChild(createMetalTagPreview('', 'Original metal tag selected', false));
            }
            window.requestAnimationFrame(autoFitAllMetalTagTexts);
        }
    }

    function updateGiftUi() {
        const giftBox = document.getElementById('giftReadyBox');
        const giftCheckbox = document.getElementById('giftReadyCheckbox');
        if (!giftBox || !giftCheckbox) return;
        giftBox.classList.toggle('is-active', giftCheckbox.checked);
        giftBox.classList.remove('has-error');
    }

    function initAddonUi() {
        const personalisationBox = document.getElementById('personalisationBox');
        const personalisationCheckbox = document.getElementById('personalisationCheckbox');
        const giftBox = document.getElementById('giftReadyBox');
        const giftCheckbox = document.getElementById('giftReadyCheckbox');
        if (personalisationCheckbox && !personalisationCheckbox.dataset.xnBound) {
            personalisationCheckbox.dataset.xnBound = 'true';
            personalisationCheckbox.addEventListener('change', updatePersonalisationUi);
        }
        if (personalisationBox) {
            personalisationBox.querySelectorAll('input[name="personalisation_option"]').forEach(function(radio) {
                if (!radio.dataset.xnBound) {
                    radio.dataset.xnBound = 'true';
                    radio.addEventListener('change', updatePersonalisationUi);
                }
            });
        }
        ['personalisationSideOneInput', 'personalisationSideTwoInput'].forEach(function(id) {
            const input = document.getElementById(id);
            if (input && !input.dataset.xnBound) {
                input.dataset.xnBound = 'true';
                input.addEventListener('input', updatePersonalisationUi);
            }
        });
        if (giftCheckbox && !giftCheckbox.dataset.xnBound) {
            giftCheckbox.dataset.xnBound = 'true';
            giftCheckbox.addEventListener('change', updateGiftUi);
        }
        if (giftBox) {
            giftBox.querySelectorAll('input[name="gift_packaging_option"]').forEach(function(radio) {
                if (!radio.dataset.xnBound) {
                    radio.dataset.xnBound = 'true';
                    radio.addEventListener('change', updateGiftUi);
                }
            });
        }
        updatePersonalisationUi();
        updateGiftUi();
        autoFitAllMetalTagTexts();
    }
    document.addEventListener('DOMContentLoaded', initAddonUi);
    initAddonUi();
    window.addEventListener('resize', function() {
        window.requestAnimationFrame(autoFitAllMetalTagTexts);
    });
    document.addEventListener('submit', async function(event) {
        const productForm = getMainProductForm(event.target);
        if (!productForm || event.target !== productForm) return;
        let selectedPersonalisation = null;
        let selectedGift = null;
        try {
            selectedPersonalisation = getSelectedPersonalisation();
            selectedGift = getSelectedGift();
        } catch (validationError) {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (validationError && validationError.message) {
                alert(validationError.message);
            }
            return;
        }
        if (!selectedPersonalisation && !selectedGift) {
            return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        if (productForm.dataset.addonsSubmitting === 'true') return;
        productForm.dataset.addonsSubmitting = 'true';
        try {
            const formData = new FormData(productForm);
            const mainVariantId = parseVariantId(formData.get('id'));
            const quantity = parseInt(formData.get('quantity') || '1', 10);
            if (!mainVariantId) {
                throw new Error('Missing main product variant.');
            }
            const mainProperties = {};
            if (selectedPersonalisation) {
                mainProperties['Personalisation Option'] = selectedPersonalisation.title;
                if (selectedPersonalisation.mode === 'one' || selectedPersonalisation.mode === 'two') {
                    mainProperties['Side 1 Text'] = selectedPersonalisation.sideOneText;
                }
                if (selectedPersonalisation.mode === 'two') {
                    mainProperties['Side 2 Text'] = selectedPersonalisation.sideTwoText;
                }
            }
            if (selectedGift) {
                mainProperties['Gift Packaging'] = selectedGift.title;
            }
            const items = [{
                id: mainVariantId,
                quantity: quantity,
                properties: mainProperties
            }];
            if (selectedPersonalisation) {
                items.push({
                    id: selectedPersonalisation.id,
                    quantity: quantity,
                    properties: {
                        '_Add-on for variant': String(mainVariantId),
                        '_Add-on type': 'Personalisation',
                        '_Personalisation option': selectedPersonalisation.title,
                        '_Side 1 Text': selectedPersonalisation.sideOneText || '',
                        '_Side 2 Text': selectedPersonalisation.sideTwoText || ''
                    }
                });
            }
            if (selectedGift) {
                items.push({
                    id: selectedGift.id,
                    quantity: quantity,
                    properties: {
                        '_Add-on for variant': String(mainVariantId),
                        '_Add-on type': 'Gift Packaging',
                        '_Gift packaging': selectedGift.title
                    }
                });
            }
            const response = await fetch(getRoot() + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                },
                body: JSON.stringify({
                    items: items
                })
            });
            if (!response.ok) {
                const errorData = await response.json().catch(function() {
                    return {};
                });
                throw new Error(errorData.description || 'Could not add selected options to cart.');
            }
            window.location.href = getRoot() + 'cart';
        } catch (error) {
            console.error('XN add-ons error:', error);
            alert(error.message || 'Something went wrong while adding the selected options.');
        } finally {
            productForm.dataset.addonsSubmitting = 'false';
        }
    }, true);

    function moveCartAddonsToBottom() {
        const cartTableBody = document.querySelector('#main-cart-items table.cart-items tbody');
        if (!cartTableBody) return;
        const rows = Array.from(cartTableBody.querySelectorAll('tr.cart-item'));
        if (!rows.length) return;
        const normalRows = rows.filter(function(row) {
            return !row.classList.contains('xn-cart-addon-item');
        });
        const addonRows = rows.filter(function(row) {
            return row.classList.contains('xn-cart-addon-item');
        });
        if (!addonRows.length) return;
        const desiredOrder = normalRows.concat(addonRows);
        const alreadyOrdered = desiredOrder.every(function(row, index) {
            return row === rows[index];
        });
        if (alreadyOrdered) return;
        desiredOrder.forEach(function(row) {
            cartTableBody.appendChild(row);
        });
    }
    document.addEventListener('DOMContentLoaded', moveCartAddonsToBottom);
    moveCartAddonsToBottom();
    const mainCartItemsContainer = document.getElementById('main-cart-items');
    if (mainCartItemsContainer) {
        const observer = new MutationObserver(function() {
            window.requestAnimationFrame(moveCartAddonsToBottom);
        });
        observer.observe(mainCartItemsContainer, {
            childList: true,
            subtree: true
        });
    }
})();